import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

interface IWorkOrderStatuses {
  isOpenedWorkOrder: boolean;
  isAssignedWorkOrder: boolean;
  isCompletedWorkOrder: boolean;
  isClosedWorkOrder: boolean;
  isCanceledWorkOrder: boolean;
}

export const requiredWorkOrderOptions = {
  select: [
    "assignedUser.firstName",
    "assignedUser.lastName",
    "assignedOn",
    "barn.name",
    "closedOn",
    "createdOn",
    "createdBy.id",
    "customerFacingId",
    "description",
    "email",
    "facility.id",
    "facility.timezone",
    "facility.name",
    "fullName",
    "id",
    "phone",
    "stallNumber",
    "status",
    "workOrderType.id",
    "workOrderType.name",
    "completedOn",
    "canceledOn",
    "minutesOpen",
    "minutesAssigned"
  ]
};

export const getWorkOrderStatus = (
  workOrder: racehorse360.IWorkOrder
): IWorkOrderStatuses => {
  const isOpenedWorkOrder =
    workOrder?.status === racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_OPEN;
  const isAssignedWorkOrder =
    workOrder?.status ===
    racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_ASSIGNED;
  const isCompletedWorkOrder =
    workOrder?.status ===
    racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_COMPLETE;
  const isClosedWorkOrder =
    workOrder?.status === racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CLOSED;
  const isCanceledWorkOrder =
    workOrder?.status ===
    racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CANCELED;

  return {
    isOpenedWorkOrder,
    isAssignedWorkOrder,
    isCompletedWorkOrder,
    isClosedWorkOrder,
    isCanceledWorkOrder
  };
};
